export default __webpack_public_path__ + "static/media/Illo_BAC.8a8c2a3a.svg";